import { render, staticRenderFns } from "./ChatBoxMessageList.vue?vue&type=template&id=641cc222&scoped=true&"
import script from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
export * from "./ChatBoxMessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxMessageList.vue?vue&type=style&index=0&id=641cc222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cc222",
  null
  
)

export default component.exports